import { Breakpoints, styled } from "@vw-marketing/us-components";

export const StyledFiltersSectionContainer = styled.div`
  position: relative;
`;

export const StyledFiltersContentContainer = styled.div`
${({ theme }) => `
  display: flex;
  justify-content: space-between;
  padding: 13px 0px;

  @keyframes fadeModalFilterDown {
    from {left: 0px;}
    to {left: 100%;}
  }

  @keyframes fadeModalFilterUp {
    from {left: 100%;}
    to {left: 0px;}
  }

  @media (min-width: ${Breakpoints.b960}px) {
    display: block;
    height: auto;
    padding: 0px;
    flex-wrap: wrap;
  }

  .filter-mobile-button {
    button {
      display: flex;
      column-gap: 4px;
      padding: 0 8px;
    }
  }

  &.opened {
    .modal-filters {
      -moz-animation: fadeModalFilterUp 0.3s ease-in 0s;
      -webkit-animation: fadeModalFilterUp  0.3s ease-in 0s;
      animation: fadeModalFilterUp  0.3s ease-in 0s;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      height: 100vh;
      left:0px;
      padding: 0 17px 0 16px;
      position: fixed;
      top: 0px;
      width: 100vw;
      z-index: 3;

      .modal_header-content {
        display: flex;
        padding: 60px 23px 0px 16px;
        button {
          position: absolute;
          top:0;
          right: 0;
          background: #DFE4E8;
          border-radius: 32px;
          margin: 16px;
        }
      }

      .modal_footer-content {
        background: #ffffff;
        background: white;
        border-top: 1px solid rgb(0,0,0,0.1);
        bottom: 0;
        column-gap: 17px;
        display: flex;
        left: 0;
        padding: 22px 20px 25px 20px;
        position: fixed;
        width: 100vw;
        z-index: 1;
      }

      .modal_filters-content {
        display: flex;
        flex-direction: column;
        max-height: calc(100vh - 192px);
        overflow-x: hidden;
        overflow-y: scroll;
        scroll-behavior: smooth;

        .build_the_deal {
          align-self: flex-start;
        }

        ::-webkit-scrollbar {
            width: 0;
        }

        ::-webkit-scrollbar-thumb {
            background: #d8d8d8;
            border-radius: 0 ;
            height: 0;
        }
      }
    }
  }
    &.hidden {
        .modal-filters {
            display: none;
        }
    }

    .filter-mobile-button {
        display: flex;
    }
    @media (min-width: ${Breakpoints.b960}px) {
        padding: 25px 0;
        width: 100%;
        .filter-mobile-button {
            display: none;
        }
        &.hidden {
            .modal-filters {
                position: relative;
                display: flex;
                flex-direction: row;
                column-gap: 30px;
            }
        }
        &.opened, &.hidden {
            align-items: center;
            display: flex;
            flex-direction: row;
            gap: 10px;
            position: relative;
            width: 100%;

            .modal-filters {
                animation: none !important;
                .modal_header-content, .modal_footer-content{
                    display: none;
                }
                .modal_filters-content {
                    column-gap: 15px;
                    display: flex;
                    flex-direction: row;
                    height: auto;
                    position: relative;

                    .button-filters-wrapper {
                        display: flex;
                        column-gap: 5px;
                        flex-direction: row;
                        .dealer-content {
                            .dealers {
                                .filter-content-wrapper {
                                    width:  ${theme.size.grid013};
                                }
                            }
                        }

                        .price-content {
                            .price {
                                .filter-content-wrapper {
                                   .apply-button  {
                                    padding: 11px 25px 18px 25px;
                                   }
                                }

                            }
                        }
                        .model-content {
                            .model {
                                .filter-content-wrapper {
                                }

                            }
                        }
                        .year-content {
                            .year {
                                .filter-content-wrapper {
                                }

                            }
                        }
                        .others-content {
                            .more-filters {
                                .filter-content-wrapper {
                                    .apply-button  {
                                        padding: 12px 25px 30px 49px;
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }

    }
    @media (min-width: ${Breakpoints.b1280}px) {
        &.opened, &.hidden {
            column-gap: 30px;
            .modal-filters {
                .modal_filters-content {
                    column-gap: 30px;
                }
            }
        }
    }
    @media (min-width: ${Breakpoints.b1920}px) {
        &.opened, &.hidden {
            .modal-filters {
                .modal_filters-content {
                    width: 100%;
                }
            }
        }
    }
`}`;

export const StyledOtherFiltersContainer = styled.div`
${() => `
    display: flex;
    flex-direction: column;
    @media screen and (min-width: ${Breakpoints.b960}px) {
        display: grid;
        grid-template-areas: 'mileage exterior interior'
        'transmission exterior interior'
        'fuel-type exterior interior';
        padding: 52px 45px 12px 45px;
        row-gap: 30px;
        column-gap: 20px;
    }
    @media screen and (min-width: ${Breakpoints.b1280}px) {
        column-gap: 95px;
    }
    .mileage {
        grid-area: mileage;
    }
    .transmission {
        grid-area: transmission;
    }
    .fuel-type  {
        grid-area: fuel-type;
    }
    .exterior-color  {
        grid-area: exterior;
        height: 100%;
    }
    .interior-color   {
        grid-area: interior;
        height: 100%;
    }
`}
`

export const StyledStickyFiltersContainer: any = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  width: 100%;
  ${props => !props.isSticky && 'display: none'}
`;

export const StyledFiltersBarContainer: any = styled.div`
  max-width: 100%;
  padding-bottom: 10px;
  scrollbar-width: none;
  width: 100%;
  ${props => props.isMobile && 'display: none'}
`;

export const StyledDropdownContainer: any = styled.div`
  display: flex;
  justify-content: ${props => props.isMobile ? 'flex-start' : 'flex-end'};
  max-width: max-content;
  padding-bottom: 10px;
  width: 100%;
`;
